import { FC } from 'react';
import { Switch } from '../Switch';

export type SwitchDarkOrLightModeProps = {
  /** true => dark mode active */
  isDarkMode: boolean;
  onClick: () => void;
  name?: string;
};

/**
 * SwitchDarkOrLightMode
 * Dark/light mode toggle built on top of Switch: sun when light (unchecked but on the right, as per DS),
 * moon when dark (checked but on the left, as per DS).
 * Colors come from the `dark` variant family in the theme (`switch.ts`); only
 * the per-state icons are passed here.
 */
export const SwitchDarkOrLightMode: FC<SwitchDarkOrLightModeProps> = ({
  isDarkMode,
  onClick,
  name,
}) => {
  const isLightMode = !isDarkMode; // Invert check to match DS where light mode is on the right

  return (
    <Switch
      variant='darkOrLightMode'
      isChecked={isLightMode}
      onClick={onClick}
      name={name}
      iconUnchecked='moon'
      iconUncheckedColor='white'
      iconChecked='sun'
      iconCheckedColor='primary'
    />
  );
};
